import { tagI } from "@/interfaces/Photo";
import "./PhotoTag.scss";

interface PhotoTagPropsI {
  tag: tagI;
}

function PhotoTag(props: PhotoTagPropsI) {
  const { tag } = props;
  return (
    <div className="photo-tag" style={{ left: tag.x, top: tag.y }}>
      <div className="tag-triangle"></div>
      <div className="tag-name-container">
        <p>{tag.name}</p>
      </div>
    </div>
  );
}

export default PhotoTag;
